import SurveyDetails from './SurveyDetails';
import './SurveyDetails.scss';

export default SurveyDetails;
